import { type IntlShape, defineMessages } from 'react-intl';

export const messages: {
	anonymous: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	anonymous: {
		id: 'content-report-table-macro.anonymous',
		defaultMessage: 'Anonymous',
		description: 'Label shown when the creator of an activity is unknown or deactivated.',
	},
});

export function normalizeCreatorDisplayName(
	displayName: string | null | undefined,
	intl: IntlShape,
): string {
	if (!displayName) {
		return intl.formatMessage(messages.anonymous);
	}

	const normalized = displayName.replace(/\s*\(Deactivated\)$/i, '').trim();
	return normalized || intl.formatMessage(messages.anonymous);
}
